import { render } from "./management.cattle.io.project.vue?vue&type=template&id=3f94b09e"
import script from "./management.cattle.io.project.vue?vue&type=script&lang=js"
export * from "./management.cattle.io.project.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__